import { render } from "./PencilSimple.vue?vue&type=template&id=01faebad"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PencilSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01faebad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01faebad', __exports__)) {
    api.reload('01faebad', __exports__)
  }
  
  module.hot.accept("./PencilSimple.vue?vue&type=template&id=01faebad", () => {
    api.rerender('01faebad', render)
  })

}


export default __exports__